import { render, staticRenderFns } from "./ViewPqr.vue?vue&type=template&id=618012e9&"
import script from "./ViewPqr.vue?vue&type=script&lang=js&"
export * from "./ViewPqr.vue?vue&type=script&lang=js&"
import style0 from "./ViewPqr.vue?vue&type=style&index=0&id=618012e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports